import React, { useState, useEffect, useContext } from "react";
import { Menu } from "semantic-ui-react";
import Underwriters from "./Underwriters";
import TitleCompanies from "./TitleCompanies";
import States from "./States";
import { UserContext } from "../User";

export default function Admin({ history, match: { path } }) {
  const { user } = useContext(UserContext);
  const [state, setState] = useState({
    selectedSection: null,
    initialLoading: true,
    noResults: false,
    sections: [
      { name: "Underwriters", path: "underwriters" },
      { name: "Title Companies", path: "title-companies" },
      { name: "States", path: "states" }
    ]
  });

  useEffect(() => {
    const selectedSection = path.split("/")[2];
    setState({
      ...state,
      selectedSection: selectedSection || state.sections[0].path,
      initialLoading: false
    });
  }, [path]);

  const userCanViewAdmin = user.isOwner || user.isOwnerPlus;

  if (!userCanViewAdmin) {
    return null;
  }

  return (
    <React.Fragment>
      <Menu tabular style={{ marginTop: 55, marginBottom: 32 }}>
        <Menu.Item
          style={{ marginLeft: 21 }}
          name="Underwriters"
          active={state.selectedSection === "underwriters"}
          onClick={() => history.push(`/admin/underwriters`)}
        />
        <Menu.Item
          name="Title Companies"
          active={state.selectedSection === "title-companies"}
          onClick={() => history.push(`/admin/title-companies`)}
        />
        <Menu.Item
          name="States"
          active={state.selectedSection === "states"}
          onClick={() => history.push(`/admin/states`)}
        />
      </Menu>
      {state.selectedSection === "underwriters" && <Underwriters />}
      {state.selectedSection === "title-companies" && <TitleCompanies />}
      {state.selectedSection === "states" && <States />}
    </React.Fragment>
  );
}
